"use strict";
export var NavBarSearchTypes = /* @__PURE__ */ ((NavBarSearchTypes2) => {
  NavBarSearchTypes2["COLLECTION_SUGGESTION"] = "collection-suggestion";
  NavBarSearchTypes2["COLLECTION_TRENDING"] = "collection-trending";
  NavBarSearchTypes2["RECENT_SEARCH"] = "recent";
  NavBarSearchTypes2["TOKEN_SUGGESTION"] = "token-suggestion";
  NavBarSearchTypes2["TOKEN_TRENDING"] = "token-trending";
  return NavBarSearchTypes2;
})(NavBarSearchTypes || {});
export var WalletConnectionResult = /* @__PURE__ */ ((WalletConnectionResult2) => {
  WalletConnectionResult2["FAILED"] = "Failed";
  WalletConnectionResult2["SUCCEEDED"] = "Succeeded";
  return WalletConnectionResult2;
})(WalletConnectionResult || {});
export var RiskCheckResult = /* @__PURE__ */ ((RiskCheckResult2) => {
  RiskCheckResult2["ERROR"] = "Error";
  RiskCheckResult2["FAILED"] = "Failed";
  RiskCheckResult2["PASSED"] = "Passed";
  return RiskCheckResult2;
})(RiskCheckResult || {});
export var AppDownloadPlatform = /* @__PURE__ */ ((AppDownloadPlatform2) => {
  AppDownloadPlatform2["ANDROID"] = "android";
  AppDownloadPlatform2["IOS"] = "ios";
  return AppDownloadPlatform2;
})(AppDownloadPlatform || {});
